import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import V5Footer from '../../components/V5Footer';
import ConsultationForm from './components/ConsultationForm';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
        <title>Start a brief · Praesidio Care</title>
        <meta
          name="description"
          content="Write to Praesidio Care in San Francisco and New York. We reply with a scope and a number."
        />
        <link rel="canonical" href="https://www.praesidiocare.com/contact" />
      </Helmet>
      <Header />
      <main className="w-site">
        <div className="w-wrap">
          <header className="w-page-hero">
            <p className="w-kicker">Contact</p>
            <h1>Send the brief. We will reply with a number.</h1>
          </header>

          <div className="w-contact" id="contact-form">
            <div>
              <p className="w-lede" style={{ marginTop: 0 }}>
                Tell us who it is for and what it has to do. If we cannot take it,
                the first reply says so.
              </p>
              <ul className="w-contact-list">
                <li>
                  <span>Email</span>
                  <a href="mailto:contact@praesidiocare.com">contact@praesidiocare.com</a>
                </li>
                <li>
                  <span>Phone</span>
                  <a href="tel:+19145709780">+1 914 570 9780</a>
                </li>
                <li>
                  <span>Studios</span>
                  <span>San Francisco and New York</span>
                </li>
              </ul>
            </div>
            <ConsultationForm />
          </div>
        </div>
      </main>
      <V5Footer />
    </>
  );
};

export default Contact;
